import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getTransactionsAsync} from "../../../stores/account/account.thunks";
import {selectLocale, selectUserAccountId, selectUserTransactions} from "../../../stores/account/account.selectors";
import moment from "moment";
import GlobalConst from "../../../constants/GlobalConst";
import {FormattedMessage, useIntl} from "react-intl";

import _ from "lodash";
import './TransactionHistoryView.style.scss'
import Pagination from "../../../components/Pagination/Pagination";
import {useNavigate} from "react-router-dom";
import pickXApi from "../../../stores/pickX/pickX.api";

const PrizeAssetRow = ({tx})=> {

    const locale = useSelector(selectLocale);
    const navigate = useNavigate();
    const description = <>{moment(tx.Parlay.DateCreated).format("MMM D")} <FormattedMessage id={`lobbyView.parlayAccordionHeader.${tx.Parlay.PayoutModel}`}/> ({tx.Parlay.ParlayNum || "✶"})</>;

    return (
        <Fragment>
            <tr className="desc mobile"
                style={{borderBottom: 'none'}}>
                <td colSpan="6" className="stockStatus text-center"
                    style={{'paddingLeft': 10}}>
                    <div className="gold-gradient-text parlayWin"
                         onClick={() => {
                        navigate(`/myaccount/mypicks/alltime?parlayId=${tx.ParlayId}`)
                    }}>{description}<br/>{tx.Parlay.PrizeAsset[`Name${_.capitalize(locale)}`]}</div>
                </td>
            </tr>
            <tr>
                <td className='date'>{moment(tx.CreationDateTime).format("MMM D, YYYY")}</td>
                <td className='desc desktop'>
                    {<div className="gold-gradient-text parlayWin"
                          onClick={() => {
                        navigate(`/myaccount/mypicks/alltime?parlayId=${tx.ParlayId}`)
                    }}>{description}<br/>{tx.Parlay.PrizeAsset[`Name${_.capitalize(locale)}`]}</div>}
                </td>
                <td className='withdraw'>{"--"}</td>
                <td className='deposit'>{"--"}</td>
                <td className='balance'>{tx.balance.toFixed(2)}</td>
            </tr>
        </Fragment>
    )
}


const TransactionHistoryView = () => {
    const dispatch = useDispatch();
    const locale = useSelector(selectLocale);
    const navigate = useNavigate();
    const intl = useIntl();
    const userTransactions = useSelector(selectUserTransactions);
    const userAccountId = useSelector(selectUserAccountId);
    const [transactions, setTransactions] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [prizeAssetsTransactions, setPrizeAssetsTransactions] = React.useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const init = async () => {
            await dispatch(getTransactionsAsync());
            const res = await dispatch(pickXApi.endpoints.getWinningPrizeAssets.initiate(undefined, { forceRefetch: true }));
            //todo: build transactions from prize assets and add to userTransactions
            if(res.isSuccess) {
                const prizeAssetsTransactions = res.data.Parlays.map(p => {
                    let parlay = {...p};
                    if (parlay.PrizeAssetId)
                        parlay.PrizeAsset = res.data.PrizeAssets.find(pa => pa.Id === parlay.PrizeAssetId);
                    if (parlay.PrizeAsset)
                        parlay.Partner = res.data.Partners.find(p => p.Id === parlay.PrizeAsset.PartnerId);

                    return {
                        transferId: parlay.Id,
                        currency: parlay.WagerCurrency,
                        isPrizeAsset: true,
                        ParlayId: parlay.Id,
                        CreationDateTime: parlay.DateCompleted,
                        Parlay: parlay

                    };
                })
                setPrizeAssetsTransactions(prizeAssetsTransactions);
            }
        }
        init();
    }, []);

    useEffect(() => {
        const xTransactions = [...(userTransactions || []),
                               ...(prizeAssetsTransactions || [])].sort((a,b) => moment(b.CreationDateTime).isAfter(moment((a.CreationDateTime))) ? 1 : -1);
        initBalance(xTransactions);
        setTransactions(xTransactions);
    }, [userTransactions, prizeAssetsTransactions]);

    let balanceMap = [];
    const initBalance = async (transfers) => {
        await transfers?.slice().reverse().reduce(( balances, transfer) => {

            let balanceKey = null;
            let displayCurrency = "";
            switch(transfer.currency){
                case "US":
                    balanceKey = "usd";
                    displayCurrency = "US";
                    break;
                case "EUR":
                case "NB_PTS":
                    balanceKey = "eur";
                    displayCurrency = "EUR";
                    break;
                case "MXN":
                    balanceKey = "mxn";
                    displayCurrency = "MXN";
                    break;
                case "ENTRYPASS":
                case "PRIZE_ASSET":
                case "TF":
                    if(GlobalConst.FEATURES.DOTCOM) {
                        balanceKey = "usd";
                        displayCurrency = "US";
                    }else {
                        balanceKey = GlobalConst.SITE_CURRENCY.toLowerCase();
                        displayCurrency = GlobalConst.SITE_CURRENCY;
                    }
                    break;
                case "TF_MXN":
                    if(GlobalConst.FEATURES.DOTCOM) {
                        balanceKey = "usd";
                        displayCurrency = "US";
                    }else {
                        balanceKey = GlobalConst.SITE_CURRENCY.toLowerCase();
                        displayCurrency = GlobalConst.SITE_CURRENCY;
                    }
                    break;
            }

            if (transfer.transferStatus == 2 || (transfer.transferType == 6 && transfer.transferStatus == 1)) {
                if (transfer.isDeposit(userAccountId))
                    balances[balanceKey] += transfer.amount;
                else
                    balances[balanceKey] -= transfer.amount;
            }

            balanceMap.push( {transferId : transfer.transferId, balance:balances[balanceKey],
                currency: displayCurrency});

            transfer.balance = balances[balanceKey];
            return balances;
        }, ({usd:0,eur:0,mxn:0}));
    }

    const tKey = "myAccountView.transactionHistory.table";

    return (
        <div className="TransactionHistoryView">
            <div className="transactionHistoryTitle gold-gradient-text">
                <FormattedMessage id={"myAccountView.transactionHistory.title"}/>
            </div>
            <div className="transaction-table">
                <table>
                    <thead>
                    <tr>
                        <th><FormattedMessage id={"myAccountView.transactionHistory.date"} /></th>
                        <th className="descHeader"><FormattedMessage id={"myAccountView.transactionHistory.description"} /></th>
                        <th><FormattedMessage id={"myAccountView.transactionHistory.withdrawals"} /></th>
                        <th><FormattedMessage id={"myAccountView.transactionHistory.deposits"} /></th>
                        <th><FormattedMessage id={"myAccountView.transactionHistory.balance"} /></th>
                    </tr>
                    </thead>
                    <tbody>
                    {transactions?.
                    slice(GlobalConst.LIMIT.TRANSACTION_PAGE_SIZE * page, (page + 1) * GlobalConst.LIMIT.TRANSACTION_PAGE_SIZE).
                    map((tx, index) => {

                        const jsonData = tx.getDataJson ? tx.getDataJson() : {};

                        let description = (tx.transferDescription || "")
                            .replace('|', ' - ')
                            .replace("Withdraw Request", intl.formatMessage({id: `${tKey}.withdrawRequest`}))
                            .replace("Completed", intl.formatMessage({id: `${tKey}.completed`}))
                            .replace("Ranked", intl.formatMessage({id: `${tKey}.ranked`}))
                            .replace("Daily", intl.formatMessage({id: `${tKey}.daily`}))
                            .replace("Weekly", intl.formatMessage({id: `${tKey}.weekly`}))
                            .replace("Monthly", intl.formatMessage({id: `${tKey}.monthly`}))
                            .replace("TournamentRegistration", intl.formatMessage({id: `${tKey}.registrationFund`}))
                            .replace("Tournament Registration Fund", intl.formatMessage({id: `${tKey}.registrationFund`}))
                            .replace("Tournament Registration Refund", intl.formatMessage({id: `${tKey}.registrationRefund`}))
                            .replace("Processing fee", intl.formatMessage({id: `${tKey}.processingFee`}))
                            .replace("Tournament", intl.formatMessage({id: `${tKey}.tournament`}))
                            .replace("Joined", intl.formatMessage({id: `${tKey}.joined`}))
                            .replace("Funds Added - Confirmation is", intl.formatMessage({id: `${tKey}.fundsAddedConfirmation`}))
                            .replace("Funds added", intl.formatMessage({id: `${tKey}.fundsAdded`}))
                            .replace("Add Funds...Pending", intl.formatMessage({id: `${tKey}.addFundsPending`}))
                            .replace("Account Created", intl.formatMessage({id: `${tKey}.accountCreated`}))


                        if(tx.isPrizeAsset)
                            return <PrizeAssetRow key={index} tx={tx} />

                        return (
                            <Fragment key={index}>
                                <tr className="desc mobile"
                                    style={{borderBottom: 'none'}}>
                                    <td colSpan="6" className="stockStatus text-center"
                                        style={{'paddingLeft': 10}}>
                                        {jsonData?.ParlayId ? <div className="gold-gradient-text parlayWin" onClick={() => {
                                            navigate(`/myaccount/mypicks/alltime?parlayId=${jsonData.ParlayId}`)
                                        }}>{description}</div> : description} <br/>
                                        {tx.transferStatus === 1 && <span>{"pending"}</span>} {tx.confirmationNumber}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='date'>{moment(tx.CreationDateTime).format("MMM D, YYYY")}</td>
                                    <td className='desc desktop'>
                                        {jsonData?.ParlayId ? <div className="gold-gradient-text parlayWin" onClick={() => {
                                            navigate(`/myaccount/mypicks/alltime?parlayId=${jsonData.ParlayId}`)
                                        }}>{description}</div> : description}
                                    </td>
                                    <td className='withdraw'>{!tx.isDeposit(userAccountId) ? tx.amount.toFixed(2) : "--"}</td>
                                    <td className='deposit'>{tx.isDeposit(userAccountId) ? tx.amount.toFixed(2) : "--"}</td>
                                    <td className='balance'>{tx.balance.toFixed(2)}</td>
                                </tr>
                            </Fragment>
                        )
                    })}
                    </tbody>
                </table>
            </div>
            <Pagination totalItems={transactions?.length}
                        itemsPerPage={GlobalConst.LIMIT.TRANSACTION_PAGE_SIZE}
                        onPageChange={(pageNumber) => setPage(pageNumber - 1)}/>
        </div>
    );
}


export default TransactionHistoryView;